import store from '@state/store'

const authRoutes = [
  {
    path: '/login',
    name: 'login',
    component: () => lazyLoadView(import('@views/pages/account/login')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({
            name: 'dashboard',
          })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => lazyLoadView(import('@views/pages/account/register')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({
            name: 'dashboard',
          })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/confirm-account',
    name: 'confirm-account',
    component: () => lazyLoadView(import('@views/pages/account/confirm')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({
            name: 'dashboard',
          })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/forget-password',
    name: 'forget-password',
    component: () =>
      lazyLoadView(import('@views/pages/account/forgetPassword')),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters['auth/loggedIn']) {
          next({
            name: 'dashboard',
          })
        } else {
          next()
        }
      },
    },
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch('auth/logOut')
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.meta.authRequired
        )
        next(
          authRequiredOnPreviousRoute
            ? {
                name: 'dashboard',
              }
            : {
                ...routeFrom,
              }
        )
      },
    },
  },
]

// error pages
const errorPagesRoutes = [
  {
    path: '/404',
    name: '404',
    component: require('@views/pages/other/error-404').default,
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/500',
    name: '500',
    component: require('@views/pages/other/error-500').default,
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '*',
    redirect: '404',
  },
]

const dashboardRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    key: 'dashboard',
    header: 'dashboard',
    icon: 'pie-chart',
    component: () => lazyLoadView(import('@views/pages/dashboard')),
    meta: {
      authRequired: true,
      permission: 'dashboard',
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
]

const transaksiRoutes = [
  {
    path: '/transaksi',
    name: 'Transaksi',
    key: 'transaksi',
    header: 'Transaksi',
    icon: 'edit',
    meta: {
      authRequired: true,
      permission: 'transaksi',
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
    children: [
      {
        name: 'Data Proyek',
        key: 'transaksi.proyek',
        path: 'proyek',
        meta: {
          authRequired: true,
          permission: 'transaksi.proyek',
        },
        component: () => lazyLoadView(import('@views/pages/transaksi/proyek')),
      },
      {
        name: 'Plan Panjar',
        key: 'transaksi.plan_panjar',
        path: 'plan-panjar',
        meta: {
          authRequired: true,
          permission: 'transaksi.plan_panjar',
        },
        component: () =>
          lazyLoadView(import('@views/pages/transaksi/plan-panjar')),
      },
      {
        name: 'Plan Tagihan',
        key: 'transaksi.plan_tagihan',
        path: 'plan-tagihan',
        meta: {
          authRequired: true,
          permission: 'transaksi.plan_tagihan',
        },
        component: () =>
          lazyLoadView(import('@views/pages/transaksi/plan-tagihan')),
      },
      {
        name: 'NPK',
        key: 'transaksi.npk',
        path: 'npk',
        meta: {
          authRequired: true,
          permission: 'transaksi.npk',
        },
        props: (route) => ({
          user: store.state.auth.currentUser || {},
        }),
        component: () => lazyLoadView(import('@views/pages/transaksi/npk')),
      },
      {
        name: 'Tagihan / Invoice',
        key: 'transaksi.tagihan',
        path: 'tagihan',
        meta: {
          authRequired: true,
          permission: 'transaksi.tagihan',
        },
        props: (route) => ({
          user: store.state.auth.currentUser || {},
        }),
        component: () => lazyLoadView(import('@views/pages/transaksi/tagihan')),
      },
      {
        name: 'Joint Plan Section (JPS)',
        key: 'transaksi.jps',
        path: 'jps',
        meta: {
          authRequired: true,
          permission: 'transaksi.jps',
        },
        component: () => lazyLoadView(import('@views/pages/transaksi/jps')),
      },
    ],
  },
]

const transaksiAddRoutes = [
  {
    path: '/transaksi/proyek/add',
    name: 'add_proyek',
    header: 'Buat Data Proyek',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/transaksi/proyek/form')),
    meta: {
      authRequired: true,
      permission: 'transaksi.proyek',
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/transaksi/proyek/:id/view',
    name: 'update_proyek',
    header: 'Update Data Proyek',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/transaksi/proyek/form')),
    meta: {
      authRequired: true,
      permission: 'transaksi.proyek',
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
]

const monitoringRoutes = [
  {
    path: '/monitoring',
    name: 'Monitoring',
    key: 'monitoring',
    header: 'Monitoring',
    icon: 'monitor',
    meta: {
      authRequired: true,
      permission: 'monitoring.proyek',
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
    children: [
      {
        name: 'Monitoring Proyek',
        key: 'monitoring.proyek',
        path: 'proyek',
        meta: {
          authRequired: true,
          permission: 'monitoring.proyek',
        },
        component: () => lazyLoadView(import('@views/pages/monitoring/proyek'))
      },
      {
        name: 'Monitoring Piutang',
        key: 'monitoring.piutang',
        path: 'piutang',
        meta: {
          authRequired: true,
          permission: 'monitoring.piutang',
        },
        component: () =>
          lazyLoadView(import('@views/pages/monitoring/piutang'))
      },
      {
        name: 'Monitoring Tagihan',
        key: 'monitoring.tagihan',
        path: 'tagihan',
        meta: {
          authRequired: true,
          permission: 'monitoring.tagihan',
        },
        component: () =>
          lazyLoadView(import('@views/pages/monitoring/tagihan'))
      },
    ],
  },
]

const laporanRoutes = [
  {
    path: '/laporan',
    name: 'Laporan',
    key: 'laporan.outlook',
    header: 'Laporan',
    icon: 'printer',
    component: () => lazyLoadView(import('@views/pages/laporan/outlook')),
    meta: {
      authRequired: true,
      permission: 'laporan.outlook',
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
    // children: [
    //   {
    //     name: 'Outlook',
    //     path: 'outlook',
    //     meta: {
    //       authRequired: true,
    //     },
    //     component: () => lazyLoadView(import('@views/pages/laporan/outlook')),
    //   },
    // ],
  },
]

const masterRoutes = [
  {
    path: '/master',
    name: 'Master',
    key: 'master',
    header: 'Master',
    icon: 'file-text',
    meta: {
      authRequired: true,
      permission: 'master',
    },
    component: {
      render(c) {
        return c('router-view')
      },
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
    children: [
      {
        name: 'Master Pemberi Kerja',
        key: 'master.pemberi_kerja',
        path: 'pemberi-kerja',
        meta: {
          authRequired: true,
          permission: 'master.pemberi_kerja',
        },
        component: () =>
          lazyLoadView(import('@views/pages/master/pemberi-kerja')),
      },
      {
        name: 'Master Witel',
        key: 'master.witel',
        path: 'witel',
        meta: {
          authRequired: true,
          permission: 'master.witel',
        },
        component: () => lazyLoadView(import('@views/pages/master/witel')),
      },
      {
        name: 'Master Pelanggan',
        key: 'master.pelanggan',
        path: 'pelanggan',
        meta: {
          authRequired: true,
          permission: 'master.pelanggan',
        },
        component: () => lazyLoadView(import('@views/pages/master/pelanggan')),
      },
      {
        name: 'Master Pengguna',
        key: 'master.pengguna',
        path: 'pengguna',
        meta: {
          authRequired: true,
          permission: 'master.pengguna',
        },
        component: () => lazyLoadView(import('@views/pages/master/pengguna')),
      },
      {
        name: 'Master Potongan RCS',
        key: 'master.potongan_rcs',
        path: 'potongan-rcs',
        meta: {
          authRequired: true,
          permission: 'master.potongan_rcs',
        },
        component: () =>
          lazyLoadView(import('@views/pages/master/potongan-rcs')),
      },
      {
        name: 'Master Pengaturan',
        key: 'master.pengaturan',
        path: 'pengaturan',
        meta: {
          authRequired: true,
          permission: 'master.pengaturan',
        },
        component: () => lazyLoadView(import('@views/pages/master/pengaturan')),
      },
    ],
  },
]

const masterCrudRoutes = [
  {
    path: '/master/pemberi-kerja/add',
    name: null,
    header: 'Data Pemberi Kerja',
    icon: 'file-text',
    component: () =>
      lazyLoadView(import('@views/pages/master/pemberi-kerja/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/pemberi-kerja/:id/view',
    name: null,
    header: 'Data Pemberi Kerja',
    icon: 'file-text',
    component: () =>
      lazyLoadView(import('@views/pages/master/pemberi-kerja/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/pemberi-kerja/:pemberi_kerja_id/segments',
    name: null,
    header: 'Data Segment Pemberi Kerja',
    icon: 'file-text',
    component: () =>
      lazyLoadView(import('@views/pages/master/pemberi-kerja/segments')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/pemberi-kerja/:pemberi_kerja_id/segments/add',
    name: null,
    header: 'Add Data Segment Pemberi Kerja',
    icon: 'file-text',
    component: () =>
      lazyLoadView(import('@views/pages/master/pemberi-kerja/segments/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/pelanggan/add',
    name: null,
    header: 'Data Pelanggan',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/master/pelanggan/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/pelanggan/:id/view',
    name: null,
    header: 'Data Pelanggan',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/master/pelanggan/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/witel/add',
    name: null,
    header: 'Data Witel',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/master/witel/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/witel/:id/view',
    name: null,
    header: 'Data Witel',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/master/witel/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/pengguna/add',
    name: null,
    header: 'Data Pengguna',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/master/pengguna/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/pengguna/:id/view',
    name: null,
    header: 'Data Pengguna',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/master/pengguna/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/potongan-rcs/add',
    name: null,
    header: 'Data Potongan RCS',
    icon: 'file-text',
    component: () =>
      lazyLoadView(import('@views/pages/master/potongan-rcs/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/master/potongan-rcs/:id/view',
    name: null,
    header: 'Data Potongan RCS',
    icon: 'file-text',
    component: () =>
      lazyLoadView(import('@views/pages/master/potongan-rcs/form')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
]

const jpsRoutes = [
  {
    path: '/transaksi/jps/add',
    name: 'jps-add',
    header: 'Buat Data JPS',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/transaksi/jps/form')),
    meta: {
      authRequired: true,
      permission: 'transaksi.jps',
      manageRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
  {
    path: '/transaksi/jps/:id',
    name: 'jps-view',
    header: 'Update Data JPS',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/transaksi/jps/form')),
    meta: {
      authRequired: true,
      permission: 'transaksi.jps',
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      mode: 'view',
    }),
  },
  {
    path: '/transaksi/jps/:id/edit',
    name: 'jps-update',
    header: 'Update Data JPS',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/transaksi/jps/form')),
    meta: {
      authRequired: true,
      permission: 'transaksi.jps',
      manageRequired: true,
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
      mode: 'edit',
    }),
  },
]

const kwitansiTagihanRoutes = [
  {
    path: '/transaksi/tagihan/:no',
    name: 'tagihan-update',
    header: 'Buat Tagihan',
    icon: 'file-text',
    component: () =>
      lazyLoadView(import('@views/pages/transaksi/tagihan/form')),
    meta: {
      authRequired: true,
      permission: 'transaksi.tagihan',
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
]

const npkRoutes = [
  {
    path: '/transaksi/npk/:no',
    name: 'npk-update',
    header: 'Buat Tagihan',
    icon: 'file-text',
    component: () => lazyLoadView(import('@views/pages/transaksi/npk/form')),
    meta: {
      authRequired: true,
      permission: 'transaksi.npk',
    },
    props: (route) => ({
      user: store.state.auth.currentUser || {},
    }),
  },
]

const mainRoutes = [
  ...dashboardRoutes,
  ...transaksiRoutes,
  ...monitoringRoutes,
  ...laporanRoutes,
  ...masterRoutes,
]

const allRoutes = [
  ...authRoutes,
  ...mainRoutes,
  ...transaksiAddRoutes,
  ...jpsRoutes,
  ...kwitansiTagihanRoutes,
  ...npkRoutes,
  ...masterCrudRoutes,
  ...errorPagesRoutes,
]

export { allRoutes, mainRoutes }

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    loading: require('@components/_loading').default,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
